import { Box, Stack, Typography } from "@mui/material";
import { FC, PropsWithChildren } from "react";

import __ from "web/Layout/Translations";

interface ISubscriptionSummaryProps {
  name: string;
  quantity: number;
}

const SubscriptionSummaryMUI: FC<
  PropsWithChildren<ISubscriptionSummaryProps>
> = ({ children, name, quantity }) => {
  return (
    <Box
      sx={{
        borderBottom: "1px solid #EEE",
        mb: 2,
        "&:last-child": {
          borderBottom: "0px",
          mb: 0,
        },
      }}
    >
      <Box
        sx={{
          bgcolor: "#E1F5FE",
          borderRadius: "16px",
          px: 2,
          py: 0.8,
          mx: { xs: 2, md: 3 },
        }}
      >
        <Typography variant="subtitle1">{name}</Typography>
        <Stack direction="row" alignItems="center">
          <Typography variant="body2">{__("Liczba osób:")}</Typography>
          <Typography variant="subtitle2" sx={{ ml: 0.5 }}>
            {quantity}
          </Typography>
        </Stack>
      </Box>
      {children}
    </Box>
  );
};

export default SubscriptionSummaryMUI;
